// extracted by mini-css-extract-plugin
module.exports = {"meal":"MealItem_meal__ho3NV","description":"MealItem_description__1LwSn","price":"MealItem_price__3T-hG"};